/**
 * ViewManager
 *
 * The main viewmanager
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.BaseView');

OT.Redesign.BaseView = (function() {
    'use strict';

    var vm = Backbone.ViewManager = Backbone.ViewManager || {};

    // base Modal view
    vm.BaseView.Modal = vm.BaseView.extend({

        events: {
            'click .page-wrapper': 'close'
        },

        onSetAttributes: function() {
            this.unset();

            this.$searchFilters = $('#search_filters');

            this.templateData = {
                Filter: this.filterType,
                FilterName: this.filterName,
                IsChangeLocationModal: this.IsChangeLocationModal,
                Labels: OT.Search.Data.get().Filters[this.filterName],
                DistanceOptions: OT.Search.Data.get().Display.DistanceOptions || [],
                MetroName: OT.Search.Data.get().Display.Metro.Name,
                Metro: OT.Search.Data.get().Display.Metro
            };

            this.$el.data('filter-name', this.filterName);
            this.$el.data('filter-type', this.filterType);

            if(this.onInitialize) {
                this.onInitialize();
            }
        },

        beforeRender: function() {
            return true;
        },

        onRender: function() {
            this.$el.show();
            this.position();

            OT.Events.fire('modal:show');

            this.$checkboxes    = this.$el.find('.checkbox:not(.select-all)');
            this.$selectAllLink = this.$el.find('.select-all');

            this.checkSearchedFilters();

            this.modalLaunchedTime  = moment().format('X');
            this.modalLaunchedCount = this.$el.find('.checkbox:checked').length;

            this.afterRender();

            return this;
        },

        checkSearchedFilters: function() {
            var checkboxes = this.$checkboxes,
                filters = OT.Search.Params.get(this.filterType.toLowerCase());

            _.each(filters, function(filterId) {
                checkboxes.filter('.checkbox[data-id="'+ filterId +'"]').prop('checked', true);
            });
        },

        position: function() {
            if(!this.$searchFilters) {
                return false;
            }

            var EnvInfo = OT.Common.EnvInfo(),
                $target = this.$target,
                isFixed = this.$searchFilters.css('position') === 'fixed';

            var buttonTop = $target.offset().top - EnvInfo.Window.scrollTop,
                top       = buttonTop,
                position  = 'fixed',
                left      = $target.offset().left + $target.outerWidth() + 5 - EnvInfo.Window.scrollLeft;

            if(isFixed) {
                position = 'fixed';
                top = $target.position().top;
                left = $target.offset().left + $target.outerWidth() + 5 - EnvInfo.Window.scrollLeft;
            }

            this.setPosition(position, top, left);

            var winHeight        = EnvInfo.Window.height,
                modalHeight      = this.$el.outerHeight(),
                modalPositionTop = this.$el.position().top;

            if(modalHeight + modalPositionTop > winHeight) {
                top += (winHeight - (modalHeight + modalPositionTop + 10));
            }

            this.setPosition(position, top, left);
        },

        setPosition: function(position, top, left) {
            this.$el.css({
                'position': position,
                'top': top,
                'left': left
            });
        },

        cancel: function() {
            this.close();

            if(this.onClose) {
                this.onClose();
            }
        },

        close: function(force) {
            if(force || this.$el.is(':visible')) {
                var ids = OT.Search.Helpers.getIdsFromCheckedItems(this.$el);

                this.unsetView();
                this.filterType = null;

                OT.Events.fire('modal:hide');

                if(this.onClose) {
                    this.onClose();
                }
            }
        },

        afterRender: function() {
            // Fired after onRender
        }

    });

})();